(function() {
  const blogPostsComponent = () => ({
    showLoadMore: true,
    loading: false,
    perPage: 9,
    loadedCount: 6,
    page: 1,

    init() {
      const section = this.$el.closest('.blog-posts');
      this.totalArticles = parseInt(section.dataset.totalArticles, 10) - 3;
      this.grid = this.$el.querySelector('.posts-grid');
      this.showLoadMore = this.loadedCount < this.totalArticles;
    },

    async loadMore() {
      if (this.loading || this.loadedCount >= this.totalArticles) return;
      this.loading = true;
      this.page++;

      try {
        const url = `/blog?section_id=blog-posts&page=${this.page}`;
        const response = await fetch(url);
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newPosts = doc.querySelectorAll('.post-card');

        if (newPosts.length > 0) {
          newPosts.forEach(post => {
            this.grid.insertAdjacentHTML('beforeend', post.outerHTML);
          });
          this.loadedCount += newPosts.length;
        }

        this.showLoadMore = this.loadedCount < this.totalArticles;
      } catch (error) {
        console.error('Error loading more posts:', error);
        this.page--;
      } finally {
        this.loading = false;
      }
    }
  });

  if (window.Alpine) {
    Alpine.data('blogPosts', blogPostsComponent);
  } else {
    document.addEventListener('alpine:init', () => {
      Alpine.data('blogPosts', blogPostsComponent);
    });
  }
})();
